"use strict";
var ko = require("knockout");
var $ = require("jquery");
var _ = require("lodash");
var pullToRefresh = require("pullToRefresh");
var ptrAnimatesMaterial = require("mobile-pull-to-refresh/dist/styles/material/animates");
var FingerprintJS = require("fingerprint");
require("./componentLoader");
require("moment");
require("../../node_modules/moment/locale/ru.js");
window["jQuery"] = window["$"] = $;
window["AppUtils"] = {};
window["AppComponents"] = {};
var viewModels = {'accountLogin': require('./viewModels/accountLogin.js'),'accountRecovery': require('./viewModels/accountRecovery.js'),'accountRegister': require('./viewModels/accountRegister.js'),'accountResetPassword': require('./viewModels/accountResetPassword.js'),'androidCollectionComments': require('./viewModels/androidCollectionComments.js'),'androidWorkStats': require('./viewModels/androidWorkStats.js'),'artView': require('./viewModels/artView.js'),'audiobookView': require('./viewModels/audiobookView.js'),'biblioNight': require('./viewModels/biblioNight.js'),'blackFriday': require('./viewModels/blackFriday.js'),'collectionComments': require('./viewModels/collectionComments.js'),'collectionView': require('./viewModels/collectionView.js'),'commentsView': require('./viewModels/commentsView.js'),'contestIndex': require('./viewModels/contestIndex.js'),'contestMyArts': require('./viewModels/contestMyArts.js'),'contestMyWork': require('./viewModels/contestMyWork.js'),'feedIndex': require('./viewModels/feedIndex.js'),'homeIndex': require('./viewModels/homeIndex.js'),'homeLibrary': require('./viewModels/homeLibrary.js'),'litmobView': require('./viewModels/litmobView.js'),'mobileLeftPanel': require('./viewModels/mobileLeftPanel.js'),'pmIndex': require('./viewModels/pmIndex.js'),'postView': require('./viewModels/postView.js'),'postsIndex': require('./viewModels/postsIndex.js'),'postsSettings': require('./viewModels/postsSettings.js'),'profileComments': require('./viewModels/profileComments.js'),'profileGuestBook': require('./viewModels/profileGuestBook.js'),'profileIndex': require('./viewModels/profileIndex.js'),'profileLibrary': require('./viewModels/profileLibrary.js'),'profilePosts': require('./viewModels/profilePosts.js'),'profileWorks': require('./viewModels/profileWorks.js'),'publisherProfileWorks': require('./viewModels/publisherProfileWorks.js'),'readerIndex': require('./viewModels/readerIndex.js'),'searchArts': require('./viewModels/searchArts.js'),'searchAuthors': require('./viewModels/searchAuthors.js'),'searchPopup': require('./viewModels/searchPopup.js'),'searchPosts': require('./viewModels/searchPosts.js'),'searchWorks': require('./viewModels/searchWorks.js'),'simpleViewModel': require('./viewModels/simpleViewModel.js'),'workBiblioNight': require('./viewModels/workBiblioNight.js'),'workDiscounts': require('./viewModels/workDiscounts.js'),'workGenre': require('./viewModels/workGenre.js'),'workGift': require('./viewModels/workGift.js'),'workPreferencesPopup': require('./viewModels/workPreferencesPopup.js'),'workRecommended': require('./viewModels/workRecommended.js'),'workSeriesView': require('./viewModels/workSeriesView.js'),'workTag': require('./viewModels/workTag.js'),'workView': require('./viewModels/workView.js')};
var utils = {'VkIdUtils': require('./utils/VkIdUtils.js'),'authorRewardUtils': require('./utils/authorRewardUtils.js'),'commentLoadUtil': require('./utils/commentLoadUtil.js'),'commentUtils': require('./utils/commentUtils.js'),'dateTimeUtils': require('./utils/dateTimeUtils.js'),'exportBookUtils': require('./utils/exportBookUtils.js'),'giftCodeUtils': require('./utils/giftCodeUtils.js'),'postUtils': require('./utils/postUtils.js'),'richContentUtils': require('./utils/richContentUtils.js')};
var customBindings = {'ko.autoSize': require('./customBindings/ko.autoSize.js'),'ko.btn': require('./customBindings/ko.btn.js'),'ko.checkedWithInit': require('./customBindings/ko.checkedWithInit.js'),'ko.dateRangePicker': require('./customBindings/ko.dateRangePicker.js'),'ko.froala': require('./customBindings/ko.froala.js'),'ko.readMore': require('./customBindings/ko.readMore.js'),'ko.time': require('./customBindings/ko.time.js'),'ko.valueWithInit': require('./customBindings/ko.valueWithInit.js')};
var dateTimeUtils_1 = require("./utils/dateTimeUtils");
var ajaxUtils_1 = require("../app/utils/ajaxUtils");
var metrikaUtils_1 = require("../app/utils/metrikaUtils");
var imageZoomUtils_1 = require("../app/utils/imageZoomUtils");
var cookieConsentUtils_1 = require("../app/utils/cookieConsentUtils");
var MobileApp = (function () {
    function MobileApp() {
        var _this = this;
        this.isKoInit = false;
        this.isInitialized = false;
        this.blockPullToRefresh = false;
        this.f7 = new Framework7({
            material: true,
            modalTitle: "Модальное окно",
            animateNavBackIcon: true,
            router: false,
            ajaxLinks: ".ajax",
            tapHold: false,
            modalButtonOk: "OK",
            modalButtonCancel: "Отмена"
        });
        ko["options"].deferUpdates = true;
        window.alert = function (message) {
            _this.f7.addNotification({ message: message, button: { text: "ОК", close: true }, hold: 3000 });
        };
    }
    MobileApp.prototype.setOptions = function (options) {
        this.isAuthenticated = options.isAuthenticated;
        this.emailConfirmed = options.emailConfirmed;
        this.rootUrl = options.rootUrl;
        this.userId = options.userId;
        this.prodEnv = options.prodEnv;
        this.isApp = options.isApp;
        this.statsApiUrl = options.statsApiUrl;
        this.webApiUrl = options.webApiUrl;
        this.yaCounterId = options.yaCounterId;
        this.yaKassaBlocked = options.yaKassaBlocked;
        if (!this.isAuthenticated) {
            $(document.body).addClass("no-auth");
        }
    };
    MobileApp.prototype.createViewModel = function (page, options) {
        if (!page)
            return {};
        var viewModel = viewModels[page];
        if (viewModel === undefined || viewModel === null) {
            throw new Error("ViewModel not found: " + page);
        }
        return new viewModel.default(options);
    };
    MobileApp.prototype.initUtils = function () {
        var _this = this;
        // Utils
        dateTimeUtils_1.default.displayTime();
        cookieConsentUtils_1.default.init();
        metrikaUtils_1.default.init("mobile");
        if (this.isApp) {
            imageZoomUtils_1.default.setNativeAppMode(this.getAppMobileHandler());
        }
        imageZoomUtils_1.default.init();
        $("select[data-smart-select]").on("change", function () {
            window.location.replace($(this).val());
        });
        if (this.isAuthenticated) {
            FingerprintJS.load().then(function (fp) { return fp.get(); }).then(function (result) {
                ajaxUtils_1.AjaxUtils.post(_this.statsApiUrl + "account/track-last-activity", { id: result.visitorId }, true);
            });
        }
        if (this.isApp) {
            var $pageContent = $(".page-content");
            $(".pull-to-refresh-material__control").appendTo($pageContent);
            var that = this;
            setTimeout(function () {
                if (!that.blockPullToRefresh) {
                    pullToRefresh({
                        container: $pageContent[0],
                        scrollable: $pageContent[0],
                        animates: ptrAnimatesMaterial,
                        refresh: function () {
                            var dfd = jQuery.Deferred();
                            setTimeout(function () {
                                window.location.reload();
                                dfd.resolve();
                            }, 200);
                            return dfd.promise();
                        }
                    });
                }
            }, 200);
        }
    };
    MobileApp.prototype.init = function (page, options) {
        var _this = this;
        if (this.isInitialized)
            return;
        this.initUtils();
        if (!this.isAuthenticated) {
            var $loginScreen = $(".popup.login-screen-content");
            if ($loginScreen[0]) {
                var loginViewModel = this.createViewModel("accountLogin");
                ko.applyBindings(loginViewModel, $loginScreen[0]);
            }
        }
        var $searchPopup = $("#searchPopup");
        if ($searchPopup[0]) {
            this.searchPopupViewModel = this.createViewModel("searchPopup", {
                urlFunc: function (genres, format, form, params) {
                    var hasForm = form !== "any";
                    var hasFormat = hasForm || format !== "any";
                    var hasGenres = hasFormat || genres != "all";
                    var genreUrlPart = hasGenres ? "/" + genres : "";
                    var formatUrlPart = hasFormat ? "/" + format : "";
                    var formUrlPart = hasForm ? "/" + form : "";
                    return "work/genre" + genreUrlPart + formatUrlPart + formUrlPart + "?" + $.param(params);
                }
            });
            ko.applyBindings(this.searchPopupViewModel, $searchPopup[0]);
            $searchPopup.on("close", function () {
                _this.searchPopupViewModel.clearQuickSearch();
            });
            $searchPopup.on("submit", "form", function () {
                _this.searchPopupViewModel.clearQuickSearch();
            });
        }
        var $leftPanel = $(".panel-left");
        if ($leftPanel[0]) {
            var loginViewModel = this.createViewModel("mobileLeftPanel");
            ko.applyBindings(loginViewModel, $leftPanel[0]);
        }
        // Dispose previous view model
        if (this.viewModel && _.isFunction(this.viewModel.dispose)) {
            this.viewModel.dispose();
        }
        this.viewModel = this.createViewModel(page, options);
        ko.applyBindings(this.viewModel, $(".view-main")[0] || $("body")[0]);
        $(function () {
            $(".popover, .picker-modal, .popup-screen-content").each(function (i, el) {
                if (!$(el).parent().is("body") && !$(el).hasClass("popover-in-component")) {
                    $(el).appendTo(document.body);
                }
            });
            $(".open-picker").on("click", function () {
                _this.showOverlayModal();
            });
            if ($("html").hasClass("dark")) {
                $("#themeTitle").text("темная");
                var currentTheme = localStorage.getItem("theme");
                if (currentTheme == null) {
                    localStorage.setItem("theme", "dark");
                }
            }
        });
        this.isInitialized = true;
    };
    MobileApp.prototype.showOverlayModal = function () {
        var _this = this;
        var $overlay = $(".modal-overlay");
        if (!$overlay[0]) {
            $overlay = $("<div></div>").addClass("modal-overlay");
            $overlay.appendTo(document.body);
        }
        $overlay.addClass("modal-overlay-visible");
        $overlay.off("click").on("click", function () {
            _this.closeModal();
            $overlay.removeClass("modal-overlay-visible");
        });
        $(".close-picker").off("click").on("click", function () {
            $overlay.removeClass("modal-overlay-visible");
        });
    };
    MobileApp.prototype.closeModal = function () {
        var modal = $(".picker-modal.modal-in, .popover.modal-in")[0];
        if (modal) {
            this.f7.closeModal(modal);
        }
    };
    MobileApp.prototype.closePopup = function () {
        var popup = $(".popup.modal-in")[0];
        if (popup) {
            this.f7.closeModal(popup);
        }
    };
    MobileApp.prototype.getAppMobileHandler = function () {
        return window["authorTodayMobileHandler"];
    };
    MobileApp.prototype.canBeHandledByApp = function () {
        return this.isApp
            && this.getAppMobileHandler() !== undefined
            && this.getAppMobileHandler() !== null;
    };
    MobileApp.prototype.showLoginPopup = function () {
        try {
            if (this.canBeHandledByApp()) {
                this.getAppMobileHandler().handleLogin();
                return;
            }
        }
        catch (e) {
            console.error(e);
        }
        this.closePopup();
        this.f7.popup("#loginPopup");
        try {
            metrikaUtils_1.default.reachGoal("showLoginForm");
        }
        catch (ex) {
            console.error(ex);
        }
    };
    MobileApp.prototype.logOff = function () {
        try {
            if (this.canBeHandledByApp()) {
                this.getAppMobileHandler().handleLogout();
                return;
            }
        }
        catch (e) {
            console.error(e);
        }
        $("#logoffForm").submit();
    };
    MobileApp.prototype.ensureAuth = function (warningMessage, onlyIfEmailConfirmed) {
        var _this = this;
        if (onlyIfEmailConfirmed === void 0) { onlyIfEmailConfirmed = false; }
        if (!this.isAuthenticated) {
            this.closeModal();
            this.f7.modal({
                title: "Нужна авторизация",
                text: "" + warningMessage + (warningMessage[warningMessage.length - 1] == '.' ? '' : '.') + " \u0412\u043E\u0439\u0442\u0438?",
                buttons: [
                    {
                        text: "Отмена",
                        onClick: function () { }
                    },
                    {
                        text: "Войти",
                        onClick: function () {
                            _this.showLoginPopup();
                        }
                    }
                ]
            });
            return false;
        }
        if (onlyIfEmailConfirmed && !this.emailConfirmed) {
            var confirmEmailUrl = this.rootUrl + "account/settings";
            this.f7.modal({
                title: "Ошибка",
                text: "Вы не подтвердили свой адрес электронной почты.",
                buttons: [
                    {
                        text: "Отмена",
                        onClick: function () { }
                    },
                    {
                        text: "Подтвердить",
                        onClick: function () {
                            _this.closePopup();
                            window.location.href = confirmEmailUrl;
                        }
                    }
                ]
            });
            return false;
        }
        return true;
    };
    MobileApp.prototype.setBlockPullToRefresh = function (block) {
        if (block === void 0) { block = true; }
        this.blockPullToRefresh = block;
    };
    MobileApp.prototype.toggleTheme = function () {
        try {
            var prefersDarkScheme = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
            var currentTheme = localStorage.getItem("theme");
            var theme;
            if (currentTheme == null) {
                theme = prefersDarkScheme && window["allowDarkTheme"] ? "light" : "dark";
            }
            else {
                theme = currentTheme === "light" ? "dark" : "light";
            }
            $("html").removeClass("light dark").addClass(theme);
            localStorage.setItem("theme", theme);
            $("#themeTitle").text(theme === "light" ? "светлая" : "темная");
            setTimeout(function () {
                $("#userMenuDropdown").addClass("open");
            }, 0);
        }
        catch (e) {
            console.error(e);
        }
    };
    return MobileApp;
}());
window["app"] = new MobileApp();
//# sourceMappingURL=mobileEntry.js.map